import { AddressModel } from "../../address.model";

export class InsuranceCompany extends AddressModel{
    name: string = "";
    policyNumber: string = "";
    policyHolder: string = "";
    phoneNumber: string = "";
    email: string = "";
}
